<div class="container-fluid" dir="rtl">
  <div class="row">
    <div class="col-sm-12 p-3">
        <!-- <div class="card"> -->
            <div class="card-body p-5">
                <form [formGroup]="userForm" class="form theme-form needs-validation">
                    <div class="row g-3">
                      <div class="col-md-2">
                        <div class="user-image">
                          <label>{{'Forms.Personal Photo' | translate}}</label>
                          <label for="img" class="box">
                            <span *ngIf="!user?.profile_photo_path && !isImgChanged">+</span>
                            <div class="avatar">
                              <img *ngIf="user?.profile_photo_path && !isImgChanged" [src]="'https://abnayiy2.s3.me-south-1.amazonaws.com/' + user?.profile_photo_path" id="staffImg" class="image" />
                            </div>
                            <div class="avatar">
                              <img *ngIf="isImgChanged" alt="" [src]="selectedImage" id="staffImg" class="image" />
                            </div>
                          </label>
                          <input id="img" (change)="handleFileInput($event)" type="file" hidden>
                          <span class="info">
                            {{'Forms.Change Personal Photo' | translate}}
                            <img src="assets/images/icons/image.svg" alt="">
                          </span>
                        </div>
                      </div>

                      <div class="col-md-10">
                        <div class="row g-3">
                          <div class="col-md-4">
                            <label for="nameAr" class="form-label">{{'Forms.Name Ar' | translate}}</label>
                            <input [ngClass]="{
                              errorInput:
                                formSubmitted && !formValid && f['full_name'].errors,
                              isValid: formSubmitted && !f['full_name'].errors
                            }" type="text" class="form-control" formControlName="full_name" id="nameAr" required placeholder="{{'Forms.Name Ar' | translate}}">
                            <app-input-error
                              [control]="userForm.get('full_name')"
                              [formSubmitted]="formSubmitted"
                            ></app-input-error>
                          </div>
                          <div class="col-md-4">
                            <label for="nameEn" class="form-label">{{'Forms.Name En' | translate}}</label>
                            <input [ngClass]="{
                              errorInput:
                                formSubmitted && !formValid && f['full_name_latin'].errors,
                              isValid: formSubmitted && !f['full_name_latin'].errors
                            }" type="text" class="form-control" formControlName="full_name_latin" id="nameEn" required placeholder="{{'Forms.Name En' | translate}}">
                            <app-input-error
                              [control]="userForm.get('full_name_latin')"
                              [formSubmitted]="formSubmitted"
                            ></app-input-error>
                          </div>
                          <div class="col-md-4">
                            <label for="nationalId" class="form-label">{{'Forms.National Id' | translate}}</label>
                            <input [ngClass]="{
                              errorInput:
                                formSubmitted && !formValid && f['national_id'].errors,
                              isValid: formSubmitted && !f['national_id'].errors
                            }" type="text" class="form-control" formControlName="national_id" id="nationalId" placeholder="{{'Forms.National Id' | translate}}" required onlyNumbers [MaxDigit]="10">
                            <app-input-error
                              [control]="userForm.get('national_id')"
                              [formSubmitted]="formSubmitted"
                              [customMsg]="{ minLength: 'رقم الهوية 10 أرقام', maxLength: 'رقم الهوية 10 أرقام' }"
                            ></app-input-error>
                          </div>
                          <div class="col-md-6">
                            <label for="email" class="form-label">{{'Forms.Email' | translate}}</label>
                            <input [ngClass]="{
                              errorInput:
                                formSubmitted && !formValid && f['email'].errors,
                              isValid: formSubmitted && !f['email'].errors
                            }" type="email" class="form-control" formControlName="email" id="email" required placeholder="{{'Forms.Email' | translate}}">
                            <app-input-error
                              [control]="userForm.get('email')"
                              [formSubmitted]="formSubmitted"
                            ></app-input-error>
                          </div>
                          <div class="col-md-6">
                            <label for="mobileNumber" class="form-label">{{'Forms.Mobile Number' | translate}}</label>
                            <div class="input-group">
                              <input [ngClass]="{
                                errorInput:
                                  formSubmitted && !formValid && f['phone'].errors,
                                isValid: formSubmitted && !f['phone'].errors
                              }" type="text" class="form-control" formControlName="phone" id="mobileNumber" placeholder="{{'Forms.Mobile Number' | translate}}" onlyNumbers [MaxDigit]="9" startPhoneFive>
                              <span class="input-group-text">966+</span>
                            </div>
                            <app-input-error
                              [control]="userForm.get('phone')"
                              [formSubmitted]="formSubmitted"
                              [customMsg]="{ minLength: 'رقم الهاتف 9 أرقام', maxLength: 'رقم الهاتف 9 أرقام' }"
                            ></app-input-error>
                          </div>
                        </div>
                      </div>
                  
                      <div class="col-md-4">
                        <label for="address" class="form-label">{{'Forms.Address' | translate}}</label>
                        <input [ngClass]="{
                          errorInput:
                            formSubmitted && !formValid && f['address'].errors,
                          isValid: formSubmitted && !f['address'].errors
                        }" type="text" class="form-control" formControlName="address" id="residentialArea" required placeholder="{{'Forms.Address' | translate}}">
                        <app-input-error
                          [control]="userForm.get('address')"
                          [formSubmitted]="formSubmitted"
                        ></app-input-error>
                      </div>
                      <!-- <div class="col-md-4">
                        <label for="residentialArea" class="form-label">{{'Forms.Residential Area' | translate}}</label>
                        <input [ngClass]="{
                          errorInput:
                            formSubmitted && !formValid && f['residential_area'].errors,
                          isValid: formSubmitted && !f['residential_area'].errors
                        }" type="text" class="form-control" formControlName="residential_area" id="residentialArea" required placeholder="{{'Forms.Residential Area' | translate}}">
                        <app-input-error
                          [control]="userForm.get('residential_area')"
                          [formSubmitted]="formSubmitted"
                        ></app-input-error>
                      </div> -->
                      <div class="col-md-4">
                        <label for="workPlace" class="form-label">{{'Forms.Work Place' | translate}}</label>
                        <input [ngClass]="{
                          errorInput:
                            formSubmitted && !formValid && f['work_place'].errors,
                          isValid: formSubmitted && !f['work_place'].errors
                        }" type="text" class="form-control" formControlName="work_place" id="workPlace" placeholder="{{'Forms.Work Place' | translate}}">
                        <app-input-error
                          [control]="userForm.get('work_place')"
                          [formSubmitted]="formSubmitted"
                        ></app-input-error>
                      </div>
                      <div class="col-md-4">
                        <label for="jobTitle" class="form-label">{{'Forms.Job Title' | translate}}</label>
                        <input [ngClass]="{
                          errorInput:
                            formSubmitted && !formValid && f['job_title'].errors,
                          isValid: formSubmitted && !f['job_title'].errors
                        }" type="text" class="form-control" formControlName="job_title" id="jobTitle" placeholder="{{'Forms.Job Title' | translate}}">
                        <app-input-error
                          [control]="userForm.get('job_title')"
                          [formSubmitted]="formSubmitted"
                        ></app-input-error>
                      </div>
                  
                      <div class="col-md-4">
                        <label for="country" class="form-label">{{'Forms.Country' | translate}}</label>
                        <select [ngClass]="{'errorInput': formSubmitted && !formValid && f['country_id'].errors, 'isValid': formSubmitted && !f['country_id'].errors }" class="form-select" required="" id="country" formControlName="country_id">
                          <option value="" disabled>{{'Forms.Choose Country' | translate}}</option>
                          <option *ngFor="let country of countries" [value]="country.id">{{ isDirRTL ? country.country_name : country.country_name_latin}}</option>
                        </select>
                        <app-input-error
                          [control]="userForm.get('country_id')"
                          [formSubmitted]="formSubmitted"
                        ></app-input-error>
                      </div>
                      <ng-container *ngIf="changePassword">
                        <div class="col-md-4">
                          <label for="password" class="form-label">{{'Forms.Password' | translate}}</label>
                          <input [ngClass]="{'errorInput': formSubmitted && !formValid && f['password'].errors, 'isValid': formSubmitted && !f['password'].errors }" type="password" class="form-control" formControlName="password" id="password" required placeholder="{{'Forms.Password' | translate}}">
                          <div class="valid-feedback">{{'Validations.Looks Good' | translate}}</div>
                          <app-input-error
                            [control]="userForm.get('password')"
                            [formSubmitted]="formSubmitted"
                            [customMsg]="{ minLength: 'الحد الأدنى 8 عناصر' }"
                          ></app-input-error>
                        </div>
                        <div class="col-md-4">
                          <label for="confirmPaasword" class="form-label">{{'Forms.Confirm Password' | translate}}</label>
                          <input [ngClass]="{'errorInput': formSubmitted && !formValid && f['password_confirmation'].errors, 'isValid': formSubmitted && !f['password_confirmation'].errors }" type="password" class="form-control" formControlName="password_confirmation" id="confirmPaasword" required placeholder="{{'Forms.Confirm Password' | translate}}">
                          <div class="valid-feedback">{{'Validations.Looks Good' | translate}}</div>
                          <app-input-error
                            [control]="userForm.get('password_confirmation')"
                            [formSubmitted]="formSubmitted"
                            [customMsg]="{ minLength: 'الحد الأدنى 8 عناصر' }"
                          ></app-input-error>
                        </div>
                      </ng-container>
                  
                      <div class="row g-3">
                        <div class="col-lg-12">
                          <label class="d-block" for="changePassword">
                            <input class="checkbox_animated" (change)="changePassword = !changePassword" formControlName="change_password" id="changePassword" type="checkbox">
                            {{'Forms.Change Password' | translate}}
                          </label>
                        </div>
                      </div>

                      <div class="media">
                        <div class="media-body text-end">
                          <label class="switch">
                            <input type="checkbox" [(ngModel)]="active" [ngModelOptions]="{standalone: true}"><span class="switch-state"></span>
                          </label>
                        </div>
                        <label class="col-form-label m-l-10 m-r-10" *ngIf="active">Active</label>
                        <label class="col-form-label m-l-10 m-r-10" *ngIf="!active">In Active</label>
                      </div>
                    </div>
                    <div class="footer-actions d-flex align-items-center">
                      <button class="btn btn-pill btn-primary mt-3" type="button" (click)="save()">{{'Forms.Update' | translate}}</button>
                      <!-- <button class="btn btn-pill btn-outline-primary mt-3 mx-3" type="button" (click)="toggleView()">{{'Forms.Cancel' | translate}}</button> -->
                    </div>
                </form>
            </div>
        <!-- </div> -->
    </div>
  </div>
</div>
